export const heroStats = [
  { value: '48h', label: '平均线索初核时间' },
  { value: '12万+', label: '累计收到有效投稿' },
  { value: '6类', label: '支持的投稿渠道' },
  { value: '100%', label: '实名信息加密保护' },
];

export const highlights = [
  {
    icon: 'ri-shield-keyhole-line',
    title: '身份可匿名保护',
    desc: '投稿时可选择匿名提交，实名信息仅用于线索核实与结果回访，不会随稿件一同公开。',
  },
  {
    icon: 'ri-file-shield-2-line',
    title: '稿件分级复核',
    desc: '每条线索先由值班编辑初核，再进入事实核查小组复评，避免因表述疏漏被直接退回。',
  },
  {
    icon: 'ri-history-line',
    title: '进度可追溯',
    desc: '提交后凭投稿编号即可查询处理进度，被采纳、需补充或未采纳都会给出明确反馈。',
  },
  {
    icon: 'ri-pencil-ruler-2-line',
    title: '格式有章可循',
    desc: '本页把格式要求、渠道区别与常见退稿原因讲清楚，照着填就能大幅提高采纳率。',
  },
];

export const formatModules = [
  {
    key: 'text',
    icon: 'ri-file-text-line',
    title: '文字线索',
    required: '必填',
    tone: 'primary',
    points: [
      '建议 300–2000 字，先写结论再写经过，避免写成散文。',
      '时间、地点、涉及对象三项必须齐全，可核实的要素越多越好。',
      '使用纯文本提交，段落之间空一行，不要直接粘贴带排版样式的稿件。',
    ],
  },
  {
    key: 'image',
    icon: 'ri-image-2-line',
    title: '图片素材',
    required: '选填',
    tone: 'secondary',
    points: [
      '支持 JPG、PNG、HEIC，单张不超过 20MB，最多同时上传 9 张。',
      '优先提交未经裁剪、未加水印的原图，便于核查时间与地点。',
      '涉及他人面部或隐私信息时，请先做必要打码或说明拍摄背景。',
    ],
  },
  {
    key: 'video',
    icon: 'ri-video-line',
    title: '视频素材',
    required: '选填',
    tone: 'accent',
    points: [
      '支持 MP4、MOV，单个文件建议不超过 500MB，超长视频可先提供片段。',
      '保留原始文件，不要二次压缩或叠加背景音乐，以免影响真实性判断。',
      '如视频包含对话，可另附文字摘要与说话人身份说明。',
    ],
  },
  {
    key: 'file',
    icon: 'ri-attachment-2',
    title: '文件与佐证',
    required: '选填',
    tone: 'primary',
    points: [
      '聊天记录、合同、票据等请导出为 PDF 或截图，并说明其来源与获取方式。',
      '同一证据请一次性打包提交，避免分多次发送导致信息碎片化。',
      '如文件涉及第三方商业秘密，请在正文中注明可公开范围。',
    ],
  },
];

export const formatChecklist = [
  '标题一句话说清事件，不超过 30 字',
  '正文包含时间、地点、人物、经过、诉求',
  '证据材料按「图片—视频—文件」分组命名',
  '留下可联系的邮箱或手机号（可要求不公开）',
  '注明是否同意编辑对稿件进行删改',
];

export const channels = [
  {
    icon: 'ri-computer-line',
    name: '网页投稿入口',
    fit: '适合材料较多、需要上传附件的线索',
    detail: '在本页底部「快速投稿」表单填写，支持同时上传图片与文件，提交后即时获得投稿编号。',
  },
  {
    icon: 'ri-mail-send-line',
    name: '邮箱投稿',
    fit: '适合长文、需要保留完整附件的线索',
    detail: '发送至 tip@baoliao51.example.com，邮件标题格式为「投稿+事件关键词+所在城市」，正文直接粘贴，附件放同一封邮件。',
  },
  {
    icon: 'ri-eye-off-line',
    name: '匿名通道',
    fit: '适合担心身份暴露、内容敏感的知情人',
    detail: '匿名通道不采集手机号，仅通过一次性回访码联系。请务必自行保存回访码，遗失后无法找回进度。',
  },
];

export const processSteps = [
  {
    step: '01',
    title: '阅读格式要求',
    desc: '先按上方的格式清单整理文字与附件，重点确认时间、地点、涉及对象三项是否齐全。',
    tip: '约六成退稿都因为要素缺失。',
  },
  {
    step: '02',
    title: '选择投稿渠道',
    desc: '材料多选网页入口，长文选邮箱，敏感线索走匿名通道。同一个线索只用一个渠道提交即可。',
    tip: '重复投放会分散核查人力。',
  },
  {
    step: '03',
    title: '填写与上传',
    desc: '勾选可公开范围与是否同意删改，按提示上传素材，确认无误后提交并记下投稿编号。',
    tip: '编号是查询进度的唯一凭证。',
  },
  {
    step: '04',
    title: '等待回访与补充',
    desc: '值班编辑一般 48 小时内初核。若需补充材料，会通过你留下的联系方式或回访码联系，请留意查收。',
    tip: '回访只会核实事实，不会索要费用。',
  },
];

export const noteGroups = [
  {
    icon: 'ri-checkbox-circle-line',
    tone: 'secondary',
    title: '建议这样做',
    items: [
      '一件事一条投稿，不要把多个互不相关的事件塞进同一份稿件。',
      '写明你的诉求：是希望核实、希望报道，还是需要转交相关部门。',
      '对外发布的截图请注明发布时间与平台，方便交叉比对。',
      '被要求补充材料时，尽量在 7 天内回复，超期线索可能转入待观察池。',
    ],
  },
  {
    icon: 'ri-close-circle-line',
    tone: 'accent',
    title: '请避免这些情况',
    items: [
      '不要编造、拼接或夸大事实，编辑会做交叉核查，虚假线索将被永久限制投稿。',
      '不要提交来源不明的他人隐私数据，如通讯录、身份证号、住址等。',
      '不要通过多个渠道重复投稿同一条线索，也不会因此加快处理。',
      '任何以「加急」「内部渠道」为名的收费行为都与本平台无关。',
    ],
  },
];

export const topics = [
  { icon: 'ri-government-line', name: '公共事务与治理', count: '3,120 条线索', desc: '公共设施、行政审批、基层治理等民生线索。' },
  { icon: 'ri-store-3-line', name: '消费与市场秩序', count: '2,480 条线索', desc: '虚假宣传、价格欺诈、售后纠纷等消费问题。' },
  { icon: 'ri-building-2-line', name: '企业与行业观察', count: '1,960 条线索', desc: '行业潜规则、企业合规、用工争议等线索。' },
  { icon: 'ri-heart-pulse-line', name: '医疗与健康安全', count: '1,240 条线索', desc: '就医体验、药品安全、卫生隐患等线索。' },
  { icon: 'ri-leaf-line', name: '环境与生态', count: '980 条线索', desc: '排污、噪声、废弃物处理与生态破坏线索。' },
  { icon: 'ri-graduation-cap-line', name: '教育与培训', count: '1,530 条线索', desc: '校园安全、培训乱象、招生争议等线索。' },
];

export const faqs = [
  {
    q: '爆料51 投稿需要实名吗？会不会公开我的信息？',
    a: '网页与邮箱通道需要留下可联系的方式用于核实，但可以选择「不公开」。联系方式不会出现在稿件正文，也不会提供给第三方。若希望连平台都不采集手机号，可使用匿名通道并保存回访码。',
  },
  {
    q: '投稿后多久会有结果？没被采纳会通知我吗？',
    a: '值班编辑一般在 48 小时内完成初核。无论是否采纳，都会给出反馈：被采纳会告知后续安排，需要补充会说明缺什么，未采纳会简述原因。请凭投稿编号查询进度。',
  },
  {
    q: '一篇投稿里可以同时放好几件事吗？',
    a: '不建议。多个互不相关的事件会显著增加核查难度，也容易因为其中一条存疑而整篇搁置。建议一事一投，把最想说明的那件事写透。',
  },
  {
    q: '图片和视频有什么格式限制？',
    a: '图片支持 JPG、PNG、HEIC，单张不超过 20MB，最多 9 张；视频支持 MP4、MOV，单个建议不超过 500MB。尽量提交未裁剪、未加滤镜的原始文件，这对事实核查帮助很大。',
  },
  {
    q: '投稿被要求补充材料，但我暂时联系不上当事人怎么办？',
    a: '先如实说明当前掌握的情况与已尝试的联系方式即可，不要凭空补充细节。编辑会根据现有材料判断是否继续跟进，你也可以在后续取得进展时凭编号追加提交。',
  },
  {
    q: '有人声称可以「付费加急」我的投稿，可信吗？',
    a: '不可信。本平台所有投稿渠道均不收取任何费用，也不存在付费加急。凡以加急、内部渠道、删除稿件为名索要钱财的，均与爆料51 无关，请勿转账并及时举报。',
  },
];

export const testimonials = [
  {
    name: '周女士',
    role: '社区业主 · 消费维权线索',
    quote: '以前投稿总被打回，说要素不全。照着指南把时间地点和票据都补齐后，第二天就收到回访，一周内给了明确答复。',
  },
  {
    name: '陈先生',
    role: '行业从业者 · 企业观察线索',
    quote: '我用的是匿名通道，回访码一直留着，全程没有暴露身份。编辑只核实事实，没有问我任何私人信息，这点让我很放心。',
  },
  {
    name: '刘同学',
    role: '高校学生 · 教育议题线索',
    quote: '一开始想把三件事写在一起，看了「一事一投」的说明后拆开提交，反馈清晰多了，也更容易被采纳。',
  },
];

export const navLinks = [
  { href: '#highlights', label: '投稿价值' },
  { href: '#format', label: '格式要求' },
  { href: '#process', label: '渠道流程' },
  { href: '#notes', label: '注意事项' },
  { href: '#topics', label: '热门主题' },
  { href: '#faq', label: '常见问题' },
];